import React, { CSSProperties, useEffect } from 'react';
import { useSimplePopUp } from './useSimplePopUp';
import {
  getProjectType,
  hasValue,
  ProjectTypes,
} from '@r-and-a-shared-ui/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import stylesPP from './scss/SimplePopUpPP.module.scss';
import stylesMMB from './scss/SimplePopUpMMB.module.scss';

export interface SimplePopUpProps {
  isVisible: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  backgroundColor?: string;
  overlayBackgroundColor?: string;
  inlineStyle?: CSSProperties;
}

export function SimplePopUp({
  isVisible,
  onClose,
  children,
  backgroundColor,
  overlayBackgroundColor,
  inlineStyle = {},
}: SimplePopUpProps) {
  const { popupRef } = useSimplePopUp({ onClose });
  const projectType = getProjectType();
  const styles =
    projectType === ProjectTypes.PlayerPortals ? stylesPP : stylesMMB;
  const isPP = projectType === ProjectTypes.PlayerPortals;

  useEffect(() => {
    if (isVisible) {
      document.body.classList.add('popup-open');
    } else {
      document.body.classList.remove('popup-open');
    }

    return () => {
      document.body.classList.remove('popup-open');
    };
  }, [isVisible]);

  if (!isVisible) return null;

  if (hasValue(backgroundColor)) {
    inlineStyle = { ...inlineStyle, backgroundColor };
  }

  const overlayStyle: CSSProperties = hasValue(overlayBackgroundColor)
    ? { backgroundColor: overlayBackgroundColor }
    : {};

  return (
    <div
      className={`${styles['overlay']} ${!isVisible ? styles['hidden'] : ''}`}
      style={overlayStyle}
    >
      <div ref={popupRef} className={styles['popup']} style={inlineStyle}>
        <button
          className={styles['close-button']}
          onClick={onClose}
          aria-label="Close"
        >
          {isPP ? <FontAwesomeIcon icon={faXmark} /> : '✖'}
        </button>
        {children}
      </div>
    </div>
  );
}

export default SimplePopUp;
